module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<div class="form-group row">\n    <label for="' +
((__t = (id)) == null ? '' : __t) +
'_buffer" class="col-sm-4 col-form-label">' +
((__t = (bufferLabel)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-8">\n        <input type="number" step="any" required="true" class="form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_buffer" name="buffer" value="' +
((__t = (bufferValue)) == null ? '' : __t) +
'">\n    </div>\n</div>\n';
if(isHalo) {;
__p += '\n<div class="form-group row">\n    <label for="' +
((__t = (id)) == null ? '' : __t) +
'_nbPoints" class="col-sm-4 col-form-label">' +
((__t = (nbPointsLabel)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-8">\n        <input type="number" step="any" class="form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_nbPoints" name="nbPoints">\n    </div>\n</div>\n';
};
__p += '\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/BufferInputDialog.ejs
// module id = 235
// module chunks = 0